import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  // bright-finder backend translations endpoint. Not currently used.
  baseUrl(localeStr) {
    const url = `${window.api_url}/v2/translations`;
    if (!localeStr) return url;

    return `${url}?filter[locale]=${localeStr}`;
  },

  async escapeHtmlEntities(string) {
    const temporaryDiv = document.createElement('div');
    temporaryDiv.innerHTML = string;
    temporaryDiv.querySelectorAll('br').forEach((lineBreak) => lineBreak.replaceWith('\n'));

    return temporaryDiv.textContent;
  },

  async index(localeStr) {
    const customTranslationsResp = await axios.get(this.baseUrl(localeStr)).catch(handleError);
    return this.transformLocaleJSON(customTranslationsResp.data);
  },

  // This fetches translations from the Translations DynamoDB table if one exists
  // and auto-translates and stores for future use if one does not exist.
  async getTranslation(languageCode, englishText, apiGatewayUrl, apiGatewayAuthKey) {
    // Check if we have the required configuration
    if (!apiGatewayUrl || !apiGatewayAuthKey) {
      console.warn('API Gateway configuration not available for translations');
      return {
        success: false,
        error: 'API Gateway configuration not available',
        originalText: englishText,
        languageCode: languageCode,
      };
    }

    // Create a separate axios instance for API Gateway calls
    const lambdaAxios = axios.create({
      withCredentials: false,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-api-key': apiGatewayAuthKey,
      },
    });

    try {
      const response = await lambdaAxios.post(`${apiGatewayUrl}/translations`, {
        id: `${languageCode}#${englishText}`,
      });

      if (response.data && response.data.translated_string) {
        const translatedString = await this.escapeHtmlEntities(response.data.translated_string);
        return {
          success: true,
          translatedString,
          originalText: englishText,
          languageCode: languageCode,
        };
      } else {
        return {
          success: false,
          error: 'No translation found',
          originalText: englishText,
          languageCode: languageCode,
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Translation service error',
        originalText: englishText,
        languageCode: languageCode,
      };
    }
  },

  transformLocaleJSON(jsonData) {
    if (!jsonData?.data) return {};

    return jsonData.data.reduce((c, d) => ((c[d.attributes.key] = d.attributes.value), c), {});
  },
};
